// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

export default function SEO({ title, description, image, url }) {
  const siteName = "Edraak"; // You can keep a global site name here
  const defaultImage = "https://i.postimg.cc/8P0MDw5Z/image.jpg"; // Path to your default image

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title ? `${title} - ${siteName}` : siteName}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || defaultImage} />
    </Helmet>
  );
}
